


































import { FamilyFilterSettings } from '@/model/family.model';
import {
  Component,
  Emit,
  Prop,
  Provide,
  Vue,
  Watch,
} from 'vue-property-decorator';

export interface Filter {
  type: string;
  value: string | number;
}

@Component
export default class FamilyFilters extends Vue {
  @Prop({ default: false }) hasNew!: boolean;

  @Provide() search: string = '';
  @Provide() filters: FamilyFilterSettings = {};

  filterByStatus() {
    let update = { ...this.filters };

    if (update.status) {
      delete update.status;
    } else {
      update = { ...this.filters, ['status']: [1] };
    }

    this.filters = { ...update };

    this.update();
  }

  filterByDoubles() {
    let update = { ...this.filters };

    if (update.doubles) {
      delete update.doubles;
    } else {
      update = { ...this.filters, ['doubles']: [1] };
    }

    this.filters = { ...update };

    this.update();
  }

  @Watch('search')
  onSearch(val: string) {
    this.filters = { ...this.filters, ['search']: [this.search] };
    this.update();
  }

  @Emit('filtersChanged')
  update(): FamilyFilterSettings {
    return this.filters;
  }
}
